import * as React from "react";

export const Section01 = () => (
  <div className="content">
    <div className="template-block">
      <img
        className="large-img"
        src="/images/resources/habits-single-page-turkish/onepage-habits-turkish.png"
        alt="Habits: Single Page Version: Turkish Translation"
      />
    </div>
  </div>
);
